/* Floodlight · ss-longform.js (content)
   Long-form pages (article, shipping policy, generic page):
   - [data-sec] / [data-secnav] active state (heading top above 34 % of the viewport)
   - nav click → smooth scroll to the section (instant under reduced motion), focus moves to the heading
   - horizontal pill nav (mobile) keeps the active pill in view
   - reading bar [data-read-bar] scaleX from scroll progress
   Port of parts/22-dom.js onScrollFrame (sections + read bar). */
(function () {
  if (window.SS_LOADED_longform) return;
  window.SS_LOADED_longform = true;

  var roots = [];
  var raf = 0;

  function reduced() {
    if (window.SS && typeof SS.reduced === 'boolean') return SS.reduced;
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }

  function ready(type, init) {
    if (window.SS && typeof SS.sectionReady === 'function') return SS.sectionReady(type, init);
    var run = function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="' + type + '"]'), function (el) { init(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  }

  function update() {
    raf = 0;
    var vh = window.innerHeight || 900;
    roots.forEach(function (st) {
      var root = st.root;
      if (!root.isConnected) return;
      var secs = root.querySelectorAll('[data-sec]');
      if (secs.length) {
        var cur = '';
        for (var i = 0; i < secs.length; i++) {
          if (secs[i].getBoundingClientRect().top < vh * 0.34) cur = secs[i].getAttribute('data-sec');
        }
        if (!cur) cur = secs[0].getAttribute('data-sec');
        if (st.sec !== cur) {
          st.sec = cur;
          Array.prototype.forEach.call(root.querySelectorAll('[data-secnav]'), function (b) {
            var on = b.getAttribute('data-secnav') === cur;
            b.classList.toggle('on', on);
            if (on) b.setAttribute('aria-current', 'location');
            else b.removeAttribute('aria-current');
            var nav = b.parentElement;
            if (on && nav && nav.scrollWidth > nav.clientWidth + 4) {
              try { nav.scrollTo({ left: Math.max(0, b.offsetLeft - 20), behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { nav.scrollLeft = Math.max(0, b.offsetLeft - 20); }
            }
          });
        }
      }
      var bar = root.querySelector('[data-read-bar]');
      if (bar) {
        var doc = document.documentElement;
        var max = Math.max(1, (doc.scrollHeight || document.body.scrollHeight) - vh);
        var y = window.scrollY || window.pageYOffset || 0;
        bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, y / max)).toFixed(4) + ')';
      }
    });
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(update);
  }

  function goTo(root, id) {
    var el = root.querySelector('[data-sec="' + id + '"]') || document.getElementById(id);
    if (!el) return;
    try { el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(); }
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) {}
    try { history.replaceState(history.state, '', '#' + id); } catch (e) {}
  }

  function init(root) {
    if (!root || root.__ssLongform) return;
    root.__ssLongform = true;
    var st = { root: root, sec: null };
    roots.push(st);
    var onClick = function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-secnav]') : null;
      if (!b || !root.contains(b)) return;
      e.preventDefault();
      goTo(root, b.getAttribute('data-secnav'));
    };
    root.addEventListener('click', onClick);
    if (roots.length === 1) {
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
    }
    // deep link: /blogs/news/x#sec-3 lands under the fixed header (scroll-margin-top does the offset)
    if (location.hash && /^#sec-\d+$/.test(location.hash)) {
      var target = root.querySelector('[data-sec="' + location.hash.slice(1) + '"]');
      if (target) setTimeout(function () { try { target.scrollIntoView({ block: 'start' }); } catch (e) {} schedule(); }, 60);
    }
    schedule();
    return function destroy() {
      root.removeEventListener('click', onClick);
      root.__ssLongform = false;
      roots = roots.filter(function (s) { return s !== st; });
      if (!roots.length) {
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
      }
    };
  }

  ready('main-article', init);
  ready('page-policy', init);
  ready('main-page', init);
})();
